import React from 'react';
import { useAppContext } from '../context/AppContext';
import EditableField from './common/EditableField';
import { formatPhoneNumber } from '../utils/format';

const PatientInfoPanel = () => {
  const { state, dispatch } = useAppContext();
  const { currentInteraction } = state;

  const handlePatientSave = (fieldName, value) => {
    const topLevelFields = { [fieldName]: value };
    dispatch({
      type: 'UPDATE_INTERACTION_DETAILS',
      payload: {
        interactionId: currentInteraction.id,
        topLevelFields: topLevelFields
      }
    });
  };

  const handleDetailSave = (fieldName, value) => {
    const newRequestContent = currentInteraction.details.request_content.map(field => {
      if (field.display_name === fieldName) {
        return { ...field, captured_content: value };
      }
      return field;
    });

    dispatch({
      type: 'UPDATE_INTERACTION_DETAILS',
      payload: {
        interactionId: currentInteraction.id,
        details: {
          ...currentInteraction.details,
          request_content: newRequestContent
        }
      }
    });
  };

  if (!currentInteraction) {
    return <div>No interaction selected.</div>;
  }

  const { details } = currentInteraction;

  const groupedDetails = details?.request_content?.reduce((acc, field) => {
    const type = field.request_content_type || 'general';
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(field);
    return acc;
  }, {});

  return (
    <div className="space-y-4">
      {/* Patient Information Card */}
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Patient Information</h3>
        <div className="space-y-3">
          <EditableField label="Name" value={currentInteraction.patientName} onSave={handlePatientSave} fieldName="patientName" />
          <EditableField label="Phone" value={formatPhoneNumber(currentInteraction.patientPhone)} onSave={handlePatientSave} fieldName="patientPhone" />
        </div>
      </div>

      {/* Dynamically generated cards from grouped details */}
      {groupedDetails && Object.entries(groupedDetails).map(([type, fields]) => (
        <div key={type} className="bg-white p-4 rounded-lg border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            {`${type.charAt(0).toUpperCase() + type.slice(1)} Information`}
          </h3>
          <div className="space-y-3">
            {fields.map((field) => (
              <EditableField
                key={field.display_name}
                label={field.display_name}
                value={field.captured_content}
                onSave={handleDetailSave}
                fieldName={field.display_name}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PatientInfoPanel; 